import Instance from '../../../../utils/Axios';

const EditarFeriasFuncionario = (ydata, feriasId, funcId, show) => async (dispatch) => {
  await Instance()
    .put(`/recursos/ferias/${feriasId}/${funcId}`, { ydata })
    .then(({ data }) => {
      dispatch({ type: 'PUT_FUNCIONARIO_FERIAS', payload: data });
      show('success', 'As Férias selecionadas, foram editadas');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        show('warning', 'Preencha todos os campos');
      }
    });
};

export default EditarFeriasFuncionario;
